import React from "react"
import {
  Header,
  Item,
  Wrapper as NavigationWrapper,
} from "../Components/Navigation"
import { PRIVACY_POLICY_CONST, PRIVACY_POLICY_SECTIONS } from "../constants"
import PrivacyPolicy from "../sections/privacy-policy"

export default ({
  history,
  legalConst,
  ssoEnabled,
}: {
  history: object
  legalConst: string
  ssoEnabled: boolean
}): JSX.Element => (
  <>
    <NavigationWrapper
      goBack={() => history.push(ssoEnabled ? "/sso/login" : "/login")}
    >
      <span>{Header(`/${legalConst}/${PRIVACY_POLICY_CONST}`)}</span>
      <div
        data-testid="legal-unauthenticated"
        className="legal-sidenav-second-tier"
      >
        <ul>
          {PRIVACY_POLICY_SECTIONS.map((section: string) =>
            Item({
              path: `legal/${section.slice(1)}`,
              history,
              prefix: ssoEnabled ? "/sso/login/" : "/",
            })
          )}
        </ul>
      </div>
    </NavigationWrapper>
    <PrivacyPolicy page={`/${legalConst}`} />
  </>
)
